import React from "react"
import FormContact from "../components/FormContact"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Testimonials from "../components/Testimonials"

const testimonials = () => {
  return (
    <Layout>
      <Seo Sitetitle="Testimonials" />
      <Testimonials />
      <FormContact
        heading="Submit a Testimonial"
        para="Have you had a great experience with our company? We’d love to hear
            about it! Please submit the testimonial form below and we will add
            it to the above testimonials."
      />
    </Layout>
  )
}

export default testimonials
